import { z } from "zod";
import { requiredFieldMessage } from "@/schemas/messages";

export const requiredEnumSchema = z.object(
  {
    "@id": z.string(),
    "@type": z.string(),
    id: z.string(),
    label: z.string(),
    value: z.string(),
  },
  {
    required_error: requiredFieldMessage,
  }
);

export const requiredEnumWithNumberValueSchema = z.object(
  {
    "@id": z.string(),
    "@type": z.string(),
    id: z.string(),
    label: z.string(),
    value: z.number(),
  },
  {
    required_error: requiredFieldMessage,
  }
);
